export default "__VITE_PUBLIC_ASSET__4387fb74__"